import React from 'react';

export const invoices = {
  id: 'billing-invoices',
  title: 'Requesting Invoices',
  description: 'How to request invoices for your purchases and set up automatic delivery.',
  category: 'billing',
  lastUpdated: '2025-06-29',
  tags: ['invoices', 'receipts', 'billing'],
  content: () => (
    <div>
      <div className="space-y-6">
        <p className="text-muted-foreground leading-relaxed">
            Invoices can be requested for your purchases. Here's how it works and how to set up automatic invoicing.
        </p>
        
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Requesting Invoices</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
            To request an invoice for your purchase:
          </p>
          <ol className="list-decimal list-inside text-muted-foreground space-y-2 ml-4">
              <li>Email me at <a href="mailto:stan@compress-glb.com" className="text-accent hover:text-accent/90">stan@compress-glb.com</a></li>
            <li>Include your account email address</li>
            <li>Specify the transaction date or amount</li>
            <li>I'll send you the invoice within 1 business day</li>
          </ol>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Automatic Invoice Setup</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
            If you need invoices for all future purchases, you can request automatic invoice delivery:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Contact me at <a href="mailto:stan@compress-glb.com" className="text-accent hover:text-accent/90">stan@compress-glb.com</a></li>
            <li>Request automatic invoice setup for your account</li>
            <li>Provide your billing email address</li>
            <li>I'll configure your account to automatically receive invoices</li>
          </ul>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Invoice Details</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
            Each invoice includes:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
            <li>Transaction date and payment details</li>
            <li>Credit package purchased</li>
            <li>Your account information</li>
            <li>Billing address (if provided)</li>
            <li>Tax information (if applicable)</li>
          </ul>
        </div>
      </div>
    </div>
  )
}; 